<script setup>
// import { Link } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import Portrait from '@/Shared/Portrait.vue'
import Icon from '@/Shared/Icon.vue'
import { useForm } from '@inertiajs/vue3'

defineProps({})

const breadcrumbs = [{ label: 'Jugadores', url: '/players' }, { label: 'Crear jugador' }]

let form = useForm({
  name: '',
  lastname: '',
  phone: '',
  email: '',
  birthdate: '',

  notes: ''
})

function store() {
  form.post('/players/store')
}
</script>

<template>
  <Portrait
    title="Crear jugador"
    subtitle="Añade un nuevo jugador al club"
    :breadcrumbs="breadcrumbs"
    :footer-actions="true"
  >
    <!-- Tarjeta principal del formulario -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6">
      <!-- Cabecera del formulario -->
      <div class="p-5 border-b border-gray-100 flex items-center">
        <div class="bg-primary-50 p-2 rounded-lg mr-3">
          <Icon name="User" class="h-5 w-5 text-primary-500" />
        </div>
        <h2 class="font-semibold text-secondary-900">Información</h2>
      </div>

      <!-- Formulario -->
      <form @submit.prevent="store">
        <div class="p-5 space-y-6">
          <!-- Datos personales -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput v-model="form.name" :error="form.errors.name" label="Nombre" required />
            <TextInput
              v-model="form.lastname"
              :error="form.errors.lastname"
              label="Apellidos"
              required
            />
          </div>

          <!-- Datos de contacto -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput
              v-model="form.phone"
              :error="form.errors.phone"
              label="Teléfono"
              type="tel"
              required
            />
            <TextInput v-model="form.email" :error="form.errors.email" label="Email" type="email" />
          </div>

          <!-- Datos adicionales -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <TextInput
              v-model="form.birthdate"
              :error="form.errors.birthdate"
              label="Fecha de nacimiento"
              type="date"
            />
          </div>

          <!-- Notas -->
          <div>
            <label class="form-label mb-2 block">Notas adicionales</label>
            <textarea
              v-model="form.notes"
              class="form-input w-full rounded-md border-gray-300 focus:border-primary-500 focus:ring focus:ring-primary-200 focus:ring-opacity-50"
              rows="3"
            ></textarea>
            <div v-if="form.errors.notes" class="form-error mt-1">{{ form.errors.notes }}</div>
          </div>
        </div>
      </form>
    </div>

    <!-- Tarjeta de ayuda -->
    <div class="bg-white rounded-xl shadow-sm border border-blue-200 overflow-hidden">
      <div class="p-5 bg-blue-50 border-b border-blue-100 flex items-center">
        <div class="bg-blue-100 p-2 rounded-lg mr-3">
          <Icon name="Information" class="h-5 w-5 text-blue-500" />
        </div>
        <h3 class="font-medium text-blue-800">Información importante</h3>
      </div>
      <div class="p-5 text-sm text-secondary-700 space-y-3">
        <p>
          <span class="font-medium">Datos obligatorios:</span> Nombre, apellidos y teléfono son
          campos obligatorios para crear un jugador.
        </p>

        <p>
          <span class="font-medium">Fecha de nacimiento:</span> Este dato es importante para
          calcular la edad del jugador y verificar su elegibilidad para ciertas categorías.
        </p>
      </div>
    </div>

    <template #footer>
      <div class="flex items-center justify-end w-full">
        <LoadingButton :loading="form.processing" class="btn-indigo" @click="store">
          Crear
        </LoadingButton>
      </div>
    </template>
  </Portrait>
</template>
